import React from 'react';

import './App.css';
import JavascriptTimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';

import UserIcon from 'material-ui/svg-icons/action/lock';
import ContactIcon from 'material-ui/svg-icons/social/group';
import ProjectIcon from 'material-ui/svg-icons/file/folder';
import CallScreenIcon from 'material-ui/svg-icons/communication/call';
import CallHistoryIcon from 'material-ui/svg-icons/action/history';
import OverviewIcon from 'material-ui/svg-icons/editor/show-chart';
// import FieldIcon from 'material-ui/svg-icons/social/group';

import { Admin, Resource, Delete } from 'admin-on-rest';

import { ContactList, ContactEdit, ContactCreate } from './contacts';
import {
  ProjectList,
  ProjectEdit,
  ProjectCreate,
  ProjectShow
} from './projects';
import { CallList } from './calls';
// import { CallCreate } from './call';
import CallScreen from './components/CallScreen';
// import { FieldList, FieldEdit, FieldCreate } from './fields';
import { UserList, UserEdit, UserCreate, UserShow } from './users';
import Dashboard from './Dashboard';
import authClient from './authClient';
import sailsClient from './aor-sails';

import projectReducer from './reducers/project';

import customRoutes from './customRoutes';
import {
  axiosErrorSaga,
  axiosLoadingStartSaga,
  axiosLoadingEndSaga
} from './sagas/axios';

import { refreshTokenSaga } from './sagas/refreshToken';
import Overview from './Overview';

// Initialize the desired locales.
JavascriptTimeAgo.locale(en);

const userReducer = (previousState = {}, { type, payload }) => {
  if (type === 'CUSTOM_EVENT') {
    return {};
  }
  return previousState;
};

const App = () => (
  <Admin
    title="Call management"
    // dashboard={Dashboard}
    authClient={authClient}
    restClient={sailsClient}
    customSagas={[
      axiosErrorSaga,
      axiosLoadingStartSaga,
      axiosLoadingEndSaga,
      refreshTokenSaga
    ]}
    customRoutes={customRoutes}
    customReducers={{ user: userReducer, project: projectReducer }}
  >
    {permissions => {
      let res = [];
      if (permissions === 'customer') {
        res = res.concat([
          <Resource
            name="projects"
            list={ProjectList}
            show={ProjectShow}
            icon={ProjectIcon}
          />
        ]);
      }
      if (permissions === 'agent') {
        res = res.concat([
          <Resource name="users" />,
          <Resource name="contacts" />,
          <Resource name="projects" />,
          <Resource
            name="call"
            options={{ label: 'Call Screen' }}
            list={CallScreen}
            edit={CallScreen}
            icon={CallScreenIcon}
          />,
          <Resource
            name="calls"
            list={CallList}
            icon={CallHistoryIcon}
            options={{ label: 'Call History' }}
          />
        ]);
      }
      if (permissions === 'admin') {
        res = res.concat([
          <Resource
            name="projects"
            list={ProjectList}
            edit={ProjectEdit}
            show={ProjectShow}
            create={ProjectCreate}
            remove={Delete}
            icon={ProjectIcon}
          />,
          <Resource
            name="calls"
            list={CallList}
            icon={CallHistoryIcon}
            options={{ label: 'Call History' }}
          />,
          <Resource
            name="contacts"
            list={ContactList}
            edit={ContactEdit}
            create={ContactCreate}
            remove={Delete}
            icon={ContactIcon}
          />,
          // <Resource
          //   name="fields"
          //   list={FieldList}
          //   edit={FieldEdit}
          //   create={FieldCreate}
          //   remove={Delete}
          //   icon={FieldIcon}
          // />,
          <Resource
            name="users"
            list={UserList}
            edit={UserEdit}
            show={UserShow}
            create={UserCreate}
            icon={UserIcon}
          />,
          <Resource
            name="call"
            options={{ label: 'Call Screen Test' }}
            list={CallScreen}
            icon={CallScreenIcon}
          />
        ]);
      }
      return res;
    }}
  </Admin>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js